import { useCreateDistributorEditableCircuit } from '@/hooks/useCircuits';
import { useToast } from '@/hooks/useToast';
import Modal from '../ui/Modal';
import { useTranslation } from '@/i18n';

interface CreateEditableCircuitModalProps {
  circuitId: string;
  closeModal: () => void;
}

const CreateEditableCircuitModal = ({
  closeModal,
  circuitId,
}: CreateEditableCircuitModalProps) => {
  const { t } = useTranslation();
  const { mutateAsync: createDistributorEditableCircuit } =
    useCreateDistributorEditableCircuit();
  const { toastAsync } = useToast();
  return (
    <Modal
      closeModal={closeModal}
      title={t('distributorCircuits.createEditableCircuit.title')}
      actionTitle={t('distributorCircuits.createEditableCircuit.actionTitle')}
      actionOnClick={() => {
        toastAsync(createDistributorEditableCircuit(circuitId), {
          success: t('distributorCircuits.createEditableCircuit.success'),
        });
      }}
      message={t('distributorCircuits.createEditableCircuit.message')}
    />
  );
};

export default CreateEditableCircuitModal;
